import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import {getMetaConfig }
    from "helpers/ConfigHelper";
import CheckBox from "components/CheckBox/CheckBox";
import Dropdown from 'components/UI/Dropdown/Dropdown';
import * as actions from 'store/actions';
import * as ConfigTypes from 'config/ConfigTypes';
import * as CartShare from "components/Cart/CartShare/CartShare";
import './CartTransport.scss'


const CartTransport = observer(
    class CartRequest extends React.Component {
        constructor(props) {
            super(props);
           this.state = {
                userInputs: {},
            }
        }

        fm = ({ id }) => {
            if (id) return this.props.intl.formatMessage({ id });
            return null;
        };

       
        handleCbChange = ({ e, el }) => {
            const { cartReqObj } = this.props.cartObjects;
            console.log("LOGS: CartTransport handleCbChange", e, el);
            this.setState({ userInputs: { ...this.state.userInputs, [el.field]: e.target.checked } }, ()=>{
                console.log("LOGS: CartSelectList this.state", this.state);
            });
            this.props.updateCartObjects({cartReqObj: {...cartReqObj, [el.field]: e.target.checked}});
        }

        onDDClick = ({ ddEl, el }) => {
             const { cartReqObj } = this.props.cartObjects;
            let ddVal = false;
            if (ddEl.name === el.name) ddVal = true;
             console.log("LOGS: CartTransport onDDClick", ddEl, el);
            this.setState({ userInputs: { ...this.state.userInputs, [el.field]: ddVal } });
            this.props.updateCartObjects({cartReqObj: {...cartReqObj, [el.field]: ddVal}});
        }


        showTotalPart = ({data, viewMode = ConfigTypes.CARTREQUEST_TOTAL}) => {
                const { cartData } = this.props.cartObjects;
                return data.map((el,idx) => {
                        if(el.type == ConfigTypes.COMPLEX ){
                        return this.showComplexElement({ el, idx, obj: cartData, viewMode});
                        }
                        return (
                        <div className="carttransport-complex">
                            <label className={el.htmlClasses ? el.htmlClasses : null}>
                                {this.fm({ id: el.intl })}
                            </label>
                            <p></p>
                        </div>
                    )
                })
        }

          showTableItem = ({ item, idx }) => {
                let viewMode = ConfigTypes.CARTREQUEST_TABLE;
                let showFields = getMetaConfig({
                    viewMode, props: this.props,
                    configName: ConfigTypes.ITEM
                });
                if (item && showFields && showFields.length) {
                    return showFields.map((el, i) => {
                        let fieldTxt = CartShare.getFieldTxt({ item: item, el, i, idx, viewMode});
                        return (
                            <div key={`showItem_${Date.now()}_${i}`} className="cartrequest-itemslist-li-group">
                                <label>{this.fm({ id: el.intl })}</label>
                                <div className={`${el.htmlClasses ? el.htmlClasses : ''}`}>{fieldTxt}</div>
                            </div>
                        )
                    })
                }
                return null;
        }

        showAdvanced = ({data}) => {
            return data.map(el => {
                if (el.show) {
                    if (el.type === ConfigTypes.CHECKBOX) {
                        return <CheckBox onCbChange={(e) => this.handleCbChange({ e, el })}
                            isChecked={this.state.userInputs[el.name]}
                            label={this.fm({ id: el.intl })} />
                    }
                    if (el.type === ConfigTypes.DROPDOWN) {
                        return (
                            <div className="cartrequest-dd-box">
                                <label>{this.fm({ id: el.intl })}</label>
                                <Dropdown
                                    data={el.data} current={this.state.userInputs[el.name]}
                                    onDDClick={(ddEl) => this.onDDClick({ ddEl, el })} />
                            </div>
                        )
                    }
                }
                return null;
            })
        }

        showLeftTotal = () => {
            return this.showTotalPart({data: ConfigTypes.CARTREQUEST_ANALOG_TOTAL});
        }
      
        showTpHeadline = () => {
            return (
                 <div className="carttransport-table-row">
                    <div className="carttransport-part-headline">
                        {this.fm({id: "cartrequest.transport_analog"})}
                    </div>
                    <div className="carttransport-part-headline">
                        {this.fm({id: "cartrequest.transport_digital"})}
                    </div>
                </div>
            )
        }

        showTpActions = () => {
            return(
                 <div className="carttransport-table-row">
                    <div className="carttransport-part-advanced">
                        {this.showAdvanced({data: ConfigTypes.CARTREQUEST_ANALOG_ACTIONS})}
                    </div>
                    <div className="carttransport-part-advanced">
                        {this.showAdvanced({data: ConfigTypes.CARTREQUEST_DIGITAL_ACTIONS})}
                    </div>
                </div>
            )
        }

        showTpDetails = () => {
            const { itemsCartList } = this.props.cartObjects;
            let leftData = itemsCartList.filter(item => item.item.awards 
                && (item.item.awards == 'VIDEO' || item.item.awards == 'FILM' ));
            let rightData = itemsCartList.filter(item => item.item.awards 
                && (item.item.awards == 'DIGITAL' || item.item.awards == 'VIDEO_DIGITAL' ))
            return(
                <div className="carttransport-table-row">
                    <div className="carttransport-part-details">
                        {(leftData && leftData.length) && leftData.map((item, idx)=> {
                            return (
                                <div className="carttransport-part-content">
                                <div>{`${item.position}. `}</div>
                                <div>
                                     {this.showTableItem({ item, idx })}
                                </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="carttransport-part-details">
                        {(rightData && rightData.length) && rightData.map((item, idx)=> {
                            return (
                            <div className="carttransport-part-content">
                                <div>{`${item.position}. `}</div>
                                <div>
                                     {this.showTableItem({ item, idx })}
                                </div>
                            </div>
                            )
                        })}
                    </div>
                </div>
            )
        }

        showTpTypes = () => {
            return (
                <div className="carttransport-table-row">
                    <div className="carttransport-part-add">
                        {ConfigTypes.CARTREQUEST_TRANSPORT_TYPES.map((el,i) => {
                            let fieldTxt = '';
                                return (
                            <div key={`showItem_${Date.now()}_${i}`} className="cartrequest-itemslist-li-group">
                                <label>{this.fm({ id: el.intl })}</label>
                                <div className={`${el.htmlClasses ? el.htmlClasses : ''}`}>{fieldTxt}</div>
                            </div>
                        )
                        })}
                    </div>
                    <div className="carttransport-part-add">
                    </div>
                </div>
            )
        }

        showTpTotal = () => {
            return(
                <div className="carttransport-table-row">
                     <div className="carttransport-part-total">
                        {this.showLeftTotal()}
                    </div>
                     <div className="carttransport-part-total">
                    </div>
                 </div>
            )
        }

        showTransport = () => {
            return(
                <div className="carttransport-transport">
                    <div className="carttransport-bold-ms">
                        {this.fm({id: 'cartrequest.transport'})}
                    </div>
                    <div className="carttransport-table">
                        {this.showTpHeadline()}
                        {this.showTpActions()}
                        {this.showTpDetails()}
                         {this.showTpTypes()}
                        {this.showTpTotal()}
                    </div>
                </div>
            )
        }


        componentDidMount() {

        }

        render() {
            return (
                <div>
                    {this.showTransport()}
                </div>
                )
        }
    }
)

const mapStateToProps = (state) => ({
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CartTransport))));


